import { IdDetalleServicioIdEstadoDto } from "./idDetalleServicioIdEstadoDto.model";

export class UpdateStatusRequest {
  idDetalleServiciosIdEstados: IdDetalleServicioIdEstadoDto[] = []
}
